import ajax from "./ajax";
import { isValidURL } from "@/util";
import defaults from "lodash/defaults";
import extend from "lodash/extend";

export function request(endpoint, options, method = "GET") {
  return new Promise((resolve, reject) => {
    // set param options
    options = options || {};

    options.params = extend(options.params || {}, {
      _method: method, // set method query var for older servers
    });

    // set base
    let base = isValidURL(endpoint)
      ? endpoint
      : wpglApi.root + wpglApi.versionString + endpoint;

    let url = base + "?" + jQuery.param(options.params);
    let data = options.data || {};

    // if not a get or post request, force post with method override
    method = method !== "GET" && method !== "POST" ? "POST" : method;

    let args = defaults(
      {
        url,
        method,
        data,
        ...(options.options || null),
        success: (...args) => {
          return resolve(args);
        },
        error: (xhr, ...args) => {
          return reject(xhr, ...args);
        },
      },
      ajax
    );

    jQuery.ajax(args);
  });
}

export default {
  get: (endpoint, options) => {
    return request(endpoint, options, "GET");
  },
  post: (endpoint, options) => {
    return request(endpoint, options, "POST");
  },
  put: (endpoint, options) => {
    return request(endpoint, options, "PUT");
  },
  patch: (endpoint, options) => {
    return request(endpoint, options, "PATCH");
  },
  delete: (endpoint, options) => {
    return request(endpoint, options, "DELETE");
  },
};
